<svg class="aayn-file-upload-item--border" xmlns="http://www.w3.org/2000/svg" #borderSvg>
    <g
        class="aayn-file-upload-item--border_group"
        stroke="var(--file-border-color)"
        stroke-linecap="round"
        stroke-width="1"
        stroke-dasharray="var(--dashArray)"
    >
        <rect
            x="0.5"
            y="0.5"
            fill="none"
            [attr.width]="(borderSvg?.getBoundingClientRect?.()?.width || 1) - 1"
            [attr.height]="(borderSvg?.getBoundingClientRect?.()?.height || 1) - 1"
        />
    </g>
</svg>
